import React from "react";
import { observer } from "mobx-react";
import dashboardStore from "../store/dashboardStore";
import { useTranslation } from "react-i18next";
import commonStore from "../../Store/marco/commonStore";

export const PageSwitch = observer(() => {
  const store = dashboardStore;
  const cmStore = commonStore;
  const { t } = useTranslation("ActivityMain");
  const tabs = ["Emission Summary", "GHG & Environmental Performance"];
  const activeColor = "rgb(2, 45, 180)";

  const handleTabClick = (i) => {
    cmStore.tryLeave(() => {
      store._handleSetSelectedDashboardPage(i);
    });
  };

  return (
    <div
      style={{
        display: "inline-flex",
        marginTop: 25,
        marginBottom: 15,
        width: "fit-content",
        border: "1px solid #ccc",
        padding: "5px",
        borderRadius: "8px",
        backgroundColor: "rgb(241,241,241)",
      }}
    >
      {tabs.map((label, i) => {
        const isActive = i === store.selectedDashboardPage;

        return (
          <button
            key={i}
            onClick={() => handleTabClick(i)}
            style={{
              position: "relative",
              fontSize: 20,
              fontWeight: 500,
              backgroundColor: isActive ? "rgb(216,226,243)" : "transparent",
              color: isActive ? activeColor : "rgb(145,145,145)",
              padding: "8px 16px",
              borderRadius: 8,
              border: isActive ? "2px solid #ccc" : "none",
              transition: "border-color 0.2s ease, color 0.2s ease",
            }}
          >
            {t(label)}
          </button>
        );
      })}
    </div>
  );
});
